import React from "react";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";

const PdfViewer = ({ pdfData }) => {
  // const [pdfData, setPdfData] = useState(null);
  const defaultLayoutPluginInstance = defaultLayoutPlugin();

  // const onFileLoad = (event) => {
  //     const file = event.target.files[0];
  //     const reader = new FileReader();
  //     reader.onload = (e) => {
  //         setPdfData(e.target.result);
  //     };
  //     reader.readAsDataURL(file);
  // };

  return (
    <div>
      {/* <input type="file" accept=".pdf" onChange={onFileLoad} /> */}
      {pdfData && (
        <Worker
          /* workerUrl={`https://unpkg.com/pdfjs-dist@2.9.359/build/pdf.worker.min.js`} */
          workerUrl={`${process.env.PUBLIC_URL}/pdf.worker.min.js`}
        >
          <div style={{ height: "500px", padding: "15px 10px" }}>
            <Viewer fileUrl={pdfData} plugins={[defaultLayoutPluginInstance]} />
          </div>
        </Worker>
      )}
    </div>
  );
};

export default PdfViewer;
